/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Subscribers/Content/BulkActions/Options/Option"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let optionTextValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'text',
})
let selectedBulkUserIdsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'bulk_user_ids',
})
let aggregateData = fromHelpers.getText(optionTextValueData, selectedBulkUserIdsValueData)
let optionDisabledValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'disabled',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 type="ghost"
 size="normal"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="option.text"
 data="selected.bulk_user_ids"
 aggregate="helpers.js getText"
 text={aggregateData}
 data="option.disabled"
 disabled={optionDisabledValueData}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}